import { ChangeDetectionStrategy, Component, EventEmitter, inject, OnInit, OutputEmitterRef } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CookieSettingsService } from './cookie-settings.service';
import { NgClass } from '@angular/common';
import { GeneralPrivacyStatementComponent } from 'app/cookiebox/components/general-privacy-statement/general-privacy-statement.component';
import { CtrlModal, CtrlModalComponent } from '@co-3/ctrl-ui/modals';

type CookieSettingsForm = {
    necessary: FormControl<boolean>;
    google: FormControl<boolean>;
    meta: FormControl<boolean>;
};

@Component({
    selector: 'app-cookie-settings',
    templateUrl: './cookie-settings.component.html',
    styleUrls: ['./cookie-settings.component.scss'],
    imports: [NgClass, ReactiveFormsModule, GeneralPrivacyStatementComponent, CtrlModalComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CookieSettingsComponent implements OnInit, CtrlModal<void> {
    public dismiss: EventEmitter<void> | OutputEmitterRef<void> = new EventEmitter<void>();

    protected form: FormGroup<CookieSettingsForm> = new FormGroup<CookieSettingsForm>({
        necessary: new FormControl<boolean>(true),
        google: new FormControl<boolean>(false),
        meta: new FormControl<boolean>(false),
    });

    protected settingsMode: 'general' | 'detailed' | 'info' = 'general';

    private cookieService = inject(CookieSettingsService);

    public ngOnInit(): void {
        this.form.patchValue({
            google: this.cookieService.cookieManager.getAllowance('ga'),
            meta: this.cookieService.cookieManager.getAllowance('meta'),
        });

        this.form.get('necessary').disable();
    }

    protected get showCookieSettings(): boolean {
        return this.cookieService.showCookieSettingsDialog();
    }

    protected submit(): void {
        this.cookieService.cookieManager.setAllAllowances({ ...this.form.value });
        this.cookieService.initScripts();
        this.cookieService.showCookieSettingsDialog.set(false);
        this.dismiss.emit();
    }

    protected acceptAll(): void {
        this.form.patchValue({
            necessary: true,
            google: true,
            meta: true,
        });
        this.submit();
    }
}
